import { Classroom } from '@teetsh/app/src/types/classroom';
import _groupBy from 'lodash-es/groupBy';
import { getNormalizedDay } from '@teetsh/app/src/containers/printUtils/getNormalizedDay';

export default function getClassroomsGroupedByWorkingDays(clrms: Classroom[]) {
  const classrooms = clrms.map(c => ({
    ...c,
    workingDays: c.workingDays.map(dd => getNormalizedDay(dd)),
  }));
  const groupedByWorkingDays = _groupBy(
    classrooms.reduce(
      (acc, num) => [
        ...acc,
        ...(num.workingDays || []).map(d => ({
          id: num.id,
          workingDay: d,
          name: num.name,
        })),
      ],
      [],
    ),
    g => g.workingDay,
  );
  return groupedByWorkingDays;
}
